/**
 * Support Contacts — request bodies (see types/support-customers.ts).
 */
import { z } from 'zod';
const text = (max) => z
    .string()
    .max(max)
    .transform((s) => s.trim() || null)
    .nullable()
    .optional();
const customerFields = {
    name: text(160),
    company: text(160),
    jobTitle: text(120),
    email: z
        .string()
        .trim()
        .max(254)
        .transform((s) => s || null)
        .pipe(z.string().email('Not a valid email address').nullable())
        .nullable()
        .optional(),
    phone: text(40),
    telegram: text(80),
    instagram: text(80),
    facebook: text(160),
    notes: text(4000),
};
const IDENTIFYING = ['name', 'email', 'phone', 'telegram', 'instagram', 'facebook'];
export const SupportCustomerInputSchema = z
    .object({
    ...customerFields,
    /** Link this inbox conversation to the new record (the inbox's "Register"). */
    conversationId: z.string().uuid().optional(),
})
    .refine((d) => IDENTIFYING.some((k) => !!d[k]), {
    message: 'Give at least a name, an email, a phone or a social handle.',
});
export const UpdateSupportCustomerSchema = z
    .object(customerFields)
    .partial()
    .refine((d) => Object.keys(d).length > 0, { message: 'At least one field must be provided' });
export const SupportCustomersQuerySchema = z.object({
    search: z.string().trim().max(120).optional(),
    limit: z.coerce.number().int().min(1).max(200).optional(),
    offset: z.coerce.number().int().min(0).optional(),
});
export const SupportCustomerIdParamSchema = z.object({ id: z.string().uuid() });
/** Link an inbox conversation to a record, or unlink it (null). */
export const SetConversationCustomerSchema = z.object({
    customerId: z.string().uuid().nullable(),
});
//# sourceMappingURL=support-customers.schema.js.map